__turbopack_context__.v({
  "arrow": "CardList-module__mplbOW__arrow",
  "badge": "CardList-module__mplbOW__badge",
  "badgePrimary": "CardList-module__mplbOW__badgePrimary",
  "badgeSuccess": "CardList-module__mplbOW__badgeSuccess",
  "badgeWarning": "CardList-module__mplbOW__badgeWarning",
  "card": "CardList-module__mplbOW__card",
  "cardBody": "CardList-module__mplbOW__cardBody",
  "cardHeader": "CardList-module__mplbOW__cardHeader",
  "cardLabel": "CardList-module__mplbOW__cardLabel",
  "cardList": "CardList-module__mplbOW__cardList",
  "cardListVertical": "CardList-module__mplbOW__cardListVertical",
  "cardRow": "CardList-module__mplbOW__cardRow",
  "cardTime": "CardList-module__mplbOW__cardTime",
  "cardTitle": "CardList-module__mplbOW__cardTitle",
  "cardValue": "CardList-module__mplbOW__cardValue",
  "container": "CardList-module__mplbOW__container",
  "containerNoBg": "CardList-module__mplbOW__containerNoBg",
  "empty": "CardList-module__mplbOW__empty",
  "fadeIn": "CardList-module__mplbOW__fadeIn",
  "hash": "CardList-module__mplbOW__hash",
  "header": "CardList-module__mplbOW__header",
  "shimmer": "CardList-module__mplbOW__shimmer",
  "skeleton": "CardList-module__mplbOW__skeleton",
  "sourceLink": "CardList-module__mplbOW__sourceLink",
  "title": "CardList-module__mplbOW__title",
  "viewAll": "CardList-module__mplbOW__viewAll",
});
